import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the main-content container to top (not window, since body is fixed)
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.scrollTo(0, 0);
    }
    // Also try window for fallback
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
